// Поля в списке
export const fields = [
    {
      title: 'Название',
      path: 'title',
      width: '30%',
    },
    {
      title: 'Символьный код',
      path: 'alias',
      width: '30%',
    },
    {
      title: 'Дата изменения',
      path: 'updated_at',
      width: '20%',
    },
    {
      title: 'Активность',
      path: 'is_active',
      width: '20%',
    },
  ];
